import PropTypes from 'prop-types';
import React from 'react';
import TreeViewNode from './TreeViewNode';
import { slugify } from 'new/utils/slugify';

export function filter(search) {
  return function (data) {
    if (!search) return true;

    const name = data.displayName || data.name;

    if (name && slugify(`${name}`.toLowerCase()).includes(slugify(search.toLowerCase()))) {
      return true;
    }

    if (data.children && data.children.length) {
      const filteredChildren = data.children.filter(filter(search));

      if (filteredChildren.length) {
        return true;
      }
    }

    return false;
  };
}

class TreeView extends React.Component {
  render() {
    const { search } = this.props;

    const data = !Array.isArray(this.props.data)
      ? this.props.data
        ? [this.props.data]
        : []
      : this.props.data;

    const filteredData = search ? data.filter(filter(search)) : data;

    return (
      <div>
        <ul className="treeview-list">
          {filteredData.map((node, index) => (
            <TreeViewNode
              key={node.id}
              node={node}
              level={1}
              onNodePreview={this.props.onNodePreview}
              onNodeSelected={this.props.onNodeSelected}
              onNodeExpandClicked={this.props.onNodeExpandClicked}
              nodeKeyName={this.props.nodeKeyName}
              selectable={this.props.selectable}
              enableFileSelection={this.props.enableFileSelection}
              selectableFileMimeType={this.props.selectableFileMimeType}
              nodeElement={this.props.nodeElement}
              selectedNodeId={this.props.selectedNodeId}
              iconClasses={this.props.iconClasses}
            />
          ))}
        </ul>
      </div>
    );
  }
}

TreeView.defaultProps = {
  selectable: true,
  enableFileSelection: false,
  nodeKeyName: 'nodes',
};

TreeView.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  selectedNodeId: PropTypes.string,
  selectable: PropTypes.bool.isRequired,
  enableFileSelection: PropTypes.bool.isRequired,
  onNodePreview: PropTypes.func.isRequired,
  onNodeSelected: PropTypes.func.isRequired,
  onNodeExpandClicked: PropTypes.func.isRequired,
  nodeKeyName: PropTypes.string,
  nodeElement: PropTypes.node.isRequired,
};

export default TreeView;
